export const theme = {
  fonts: {
    body: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif",
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
  },
  radius: {
    sm: 6,
    md: 10,
    lg: 16,
    full: 9999,
  },
  colors: {
    primary: '#2563eb',
    surface: '#0f172a',
    text: '#0f172a',
    muted: '#94a3b8',
    border: '#1f2937',
    bg: '#fff',
  },
  toaster: {
	position: "top-center",
	autoHideDuration: 3000,
  },
} as const;

export type AppTheme = typeof theme;
